const css = require('./ayu-light.css')

/* eslint-disable */
ace.define('ace/theme/ayu-light', ['require', 'exports', 'module', 'ace/lib/dom'], function (require, t, n) {
  t.isDark = false
  t.cssClass = 'ace-ayu-light'
  t.cssText = css
  var r = require('../lib/dom')
  r.importCssString(t.cssText, t.cssClass)
});
(function () {
  ace.require(['ace/theme/ayu-light'], function (m) {
    if (typeof module == 'object' && typeof exports == 'object' && module) {
      module.exports = m
    }
  })
})()
